import React from "react";
import GenericCheckbox from "@frameworks/shared-library/components/GenericCheckbox/GenericCheckbox";
import GenericTooltip from "@frameworks/web/components/generic/GenericTooltip";
import GenericTooltipInnerContent from "@frameworks/shared-library/components/GenericTooltipInnerContent";
var LongTermUnitsCheckbox = function (props) {
    var isChecked = props.isChecked, onLongTermUnitsChange = props.onLongTermUnitsChange;
    var handleOnChangeCheckbox = function (e) {
        onLongTermUnitsChange === null || onLongTermUnitsChange === void 0 ? void 0 : onLongTermUnitsChange(e.target.checked);
    };
    var checkboxProps = {
        checked: isChecked,
        id: "1",
        value: "longTermUnits",
        name: "longTermUnits",
        onChange: handleOnChangeCheckbox,
        className: "m-0",
    };
    return (React.createElement("div", { className: "checkbox-section d-flex align-items-start justify-content-center position-relative ".concat(props.parentClassName ? props.parentClassName : ""), id: "long-term-units-checkbox-section" },
        React.createElement(GenericCheckbox, { parentClassName: "individual-checkbox-wrapper", checkboxProps: checkboxProps, labelProps: {
                htmlFor: "",
                className: "txt_black-One1",
                children: React.createElement(React.Fragment, null),
            }, checkboxType: "han-blue" }),
        React.createElement("div", { className: "d-flex flex-column" },
            React.createElement("div", { className: "d-flex gap-2 align-items-center" },
                React.createElement("label", { htmlFor: "longTermUnits", className: "checkbox-label DMSan_14_500" }, props.headerLabel),
                React.createElement(GenericTooltip, { placement: "top-start", toolTipText: React.createElement(GenericTooltipInnerContent, { tooltipTitle: "Approximate amount and units will auto-fill based on your long-term holdings." }), triggerType: "hover", toolTipClassName: "txn-mf-tooltip-info", noButton: true, button: React.createElement("i", { className: "edel-icon-Information txt_secondary-gray info-block fs-15" }), container: function () {
                        return document.getElementById("long-term-units-checkbox-section");
                    } })),
            React.createElement("div", { className: "checkbox-help DMSansNormal_12_400" }, props === null || props === void 0 ? void 0 : props.footerLabel))));
};
export default LongTermUnitsCheckbox;
